<template>
    <div>
        <div v-show="!loading">
            <div v-html="svg_loaded" class="text-center"></div>

            <template v-if="!loading && load_popover">
                <b-popover v-for="zona in secciones" :key="zona.id" :target="'popover-' + zona.id" triggers="hover focus">
                    <template slot="title">{{ zona.name }}</template>
                    <span v-if="!zona.esta_disponible && zona.tiene_precios">{{ $t('partidos.agotadas') }}</span>
                    <span v-else-if="!zona.esta_disponible && !zona.tiene_precios">{{ $t('mapa.no_disponible') }}</span>
                </b-popover>
            </template>
        </div>
        <template v-if="loading">
            <div class="col-12 text-center" style="height: 400px">
                <LoaderComponent/>
            </div>
        </template> 
    </div>
</template>

<script>
    export default {
        props: ['secciones', 'event', 'sesion_id', 'zona_id'],
        data() {
            return {
                svg_loaded : '',
                loading: true,
                can_click: true,
                load_popover: true
            }            
        },
        created() {
            this.getSvgCode();

            let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if(/windows phone/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/android/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                this.load_popover = false;
            }

        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        methods : {
            getSvgCode() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                    },
                    tid: this.configuracion.hash_teatro,
                    event_id: this.event.id,
                    sesion_id: this.sesion_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.evento.sesion.secciones.svg'), params).then(res => {
                    this.loadSVG(res.data.svg);
                });
            },
            loadSVG(svg) {
                this.svg_loaded = svg;

                var vue_instance = this;

                setTimeout(() => {
                    var regions = document.getElementsByClassName("recinto-zona");

                    for(var i in regions) {
                        if(regions[i].dataset !== undefined) {
                            for(let j in this.secciones) {
                                if(this.secciones[j].id == regions[i].dataset.region) {
                                    if (!this.secciones[j].esta_disponible && this.$route.name != 'back.events.venta' && this.$route.name != 'back.events.sesion.bloquear-asientos') {
                                        regions[i].classList.add('plaza_ocupada');
                                    } else {
                                        regions[i].addEventListener('click', function() {
                                            vue_instance.clickRegion(this.dataset.region);
                                        }, false);
                                    }
                                }
                            }
                        }                                                                                            
                    }
                    
                    this.loading = false;
                    this.$emit('cargado');
                }, 1000);                
            },
            clickRegion : function(region_id) {
                let zona = null;
                for(let i in this.secciones) {
                    if(this.secciones[i].id == region_id) {
                        zona = this.secciones[i];
                    }
                }

                if(zona) {
                    this.$emit('clickZona', zona);
                }            
            }        
        }
    }
</script>